/**
 * [ File :: G_ImagePortal.js ]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/image/G_ImagePortal.js
 * @목적 : 이미지로 구성된 포탈객체
 * @진행 : 종료
 * @주의 : 없음
 * @일자 : 2018.mm.dd
 * @작성 : created by SDM
 * @참조 :
 */

import G_ImageGrid from 'canvas/grid/dev/child/image/G_ImageGrid';
import G_Define    from 'canvas/grid/dev/util/G_Define';

const G_ImagePortal = (function() {

	return class extends G_ImageGrid {
		constructor(obj) {
			super(obj);

			// [S] 포탈 애니메이션 설정
			let stage = this._objParent._container;
			let emitter = this.CODMOS.ANIMATE._proton.smoke(
				stage,
				this._pixelX,
				this._pixelY,
				this._gridDisX,
				G_Define.PORTAL_COLOR
			);
			if(!this._active) emitter.stopEmit(); // 활성여부확인
			this._arrAnimate.push({ type  : "proton", value : emitter });
		}

		/**
		 * [ Function (protected) :: _movePortal ]
		 *
		 * @DES :: 포탈이용
         * @IP1 :: obj {obj}
         * @IP2 :: cb {func}
		 */
		_movePortal(hero, cb) {

			/**
			 * [STEP]
			 *
			 * 01. => 자신 활성화여부는 이미 확인 :: 앞에서 처리
			 * 02. 타켓포탈 활성화여부 확인하기
			 * 03. 밟힘 애니메이션
			 * 04. 포탈 애니메이션
			 * */

			// # 01.
			let target = this.CODMOS.WORLD[this._target];
			if(target && target._active) {
				// # 02. 밟힘 애니메이션
				let pathList = this.CODMOS.WORLD.LIST.path;
				for(let key in pathList) {
					if(
						pathList[key]._gridX == target._gridX
						&&
						pathList[key]._gridY == target._gridY
					) {
						this.CODMOS.ANIMATE._tween.beStepped(pathList[key]);
					}
				}

				// # 03. 포탈 애니메이션
				this.CODMOS.ANIMATE._tween.portal(hero, target._pixelX, target._pixelY, () => {
					hero._setGridXWithPixel(target._gridX);
					hero._setGridYWithPixel(target._gridY);
					if(cb) cb();
				});
			} else if(cb) cb();

		}

	}
}());

export default G_ImagePortal;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/image/G_ImagePortal.js